import React from 'react'
import ClienteSelect from '../../components/molecules/ClienteSelect'

export default function ClienteField({
  clienti = [],
  selectedClientId = '',
  setSelectedClientId,
  setBrand,
  helpText = 'Il backend sincronizza automaticamente il brand legacy.',
}) {
  return (
    <ClienteSelect
      id="llm-visibility-cliente"
      label="Cliente"
      clienti={clienti}
      selectedClientId={selectedClientId}
      onChange={(value) => {
        setSelectedClientId(value)
        const selectedCliente = clienti.find((cliente) => String(cliente.id) === String(value))
        setBrand(selectedCliente?.nome || '')
      }}
      isRequired
      helpText={helpText}
      showCreateLink
    />
  )
}
